document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".home-top__video")) {
    const container = document.querySelector(".home-top__video");
    const video = document.getElementById("homeTopVideo");

    if (!container || !video) return;

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    const videoSrc = isMobile
      ? container.dataset.mobileVideo
      : container.dataset.desktopVideo;

    const source = document.createElement("source");
    source.src = videoSrc;
    source.type = "video/mp4";
    video.appendChild(source);

    video.load();
  }

  if (document.querySelector("main.index-main")) {
    const parallax = document.querySelectorAll(
      "main.index-main .shopify-section"
    )[0];
    const sections = document.querySelectorAll(
      "main.index-main .shopify-section"
    );

    window.addEventListener("scroll", function () {
      let offset = window.pageYOffset;
      parallax.querySelector("div").style.backgroundPositionY =
        offset * 0.9 + "px";
    });
    const observer3 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            setTimeout(function () {
              entry.target.classList.remove("visible");
            }, 10000);
          }
        });
      },
      {
        threshold: [0.1, 0.9],
      }
    );
  }

  const galleryImages = document.querySelectorAll(".product__media-item");
  const thumbnails = document.querySelectorAll(".thumbnail-list__item");

  const observer1 = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const imageId = entry.target.dataset.mediaId;

        if (entry.isIntersecting) {
          thumbnails.forEach((thumbnail) => {
            if (thumbnail.dataset.target === imageId) {
              thumbnail.classList.add("active");
            } else {
              thumbnail.classList.remove("active");
            }
          });
        }
      });
    },
    {
      root: null,
      threshold: 0.5,
    }
  );

  galleryImages.forEach((image) => observer1.observe(image));

  if (document.querySelector(".product-more-colors")) {
    document
      .querySelector(".product-more-colors")
      .addEventListener("click", function () {
        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__colors")
          .classList.toggle("visible");
       
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__colors"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }

        document.querySelector("body").style.overflow = "hidden";

        document.querySelector(
          ".product--thumbnail_slider .thumbnail-slider"
        ).style.display = "none";
      });
  }
  if (document.querySelector(".product-more-pendants")) {
    document
      .querySelector(".product-more-pendants")
      .addEventListener("click", function () {
        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__pendants")
          .classList.toggle("visible");
       
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__pendants"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }

        document.querySelector("body").style.overflow = "hidden";

        document.querySelector(
          ".product--thumbnail_slider .thumbnail-slider"
        ).style.display = "none";
      });
  }
  if (document.querySelector(".product-modal-description p")) {
    document
      .querySelector(".product-modal-description p")
      .addEventListener("click", function () {
        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__essence")
          .classList.toggle("visible");
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__essence"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector(
          ".product--thumbnail_slider .thumbnail-slider"
        ).style.display = "none";
      });
  }
  if (document.querySelector(".product-modal-packaging p")) {
    document
      .querySelector(".product-modal-packaging p")
      .addEventListener("click", function (e) {
        document.documentElement.style.scrollBehavior = "auto";
        e.preventDefault();
        e.stopPropagation();

        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__packaging")
          .classList.toggle("visible");
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__packaging"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector(
          ".product--thumbnail_slider .thumbnail-slider"
        ).style.display = "none";
      });
  }

   if (document.querySelector(".product-modal-notes p")) {
    document
      .querySelector(".product-modal-notes p")
      .addEventListener("click", function (e) {
        document.documentElement.style.scrollBehavior = "auto";
        e.preventDefault();
        e.stopPropagation();

        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__notes")
          .classList.toggle("visible");
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__notes"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector(
          ".product--thumbnail_slider .thumbnail-slider"
        ).style.display = "none";
      });
  }

  if (document.querySelector(".modal-product__close")) {
    document
      .querySelector(".modal-product__close")
      .addEventListener("click", function () {
        const parent = this.closest(".modal-product__form");
        if (parent) {
          parent.classList.remove("visible");
        }
      });
  }
  if (document.querySelector(".product-modal-difference p")) {
    document
      .querySelector(".product-modal-difference p")
      .addEventListener("click", function () {
        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__differences")
          .classList.toggle("visible");
        document
          .querySelector(".modal-product__differences .modal-product__body").style.display = 'block'; 
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__differences"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }
        document.querySelector("body").style.overflow = "hidden";
        if (
          document.querySelector(".product--thumbnail_slider .thumbnail-slider")
        ) {
          document.querySelector(
            ".product--thumbnail_slider .thumbnail-slider"
          ).style.display = "none";
        }
      });
  }
  if (document.querySelector(".product-modal-art p")) {
    document
      .querySelector(".product-modal-art p")
      .addEventListener("click", function () {
        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__art")
          .classList.toggle("visible");
        document
          .querySelector(".modal-product__art .modal-product__body").style.display = 'block'; 
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__art"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }
        document.querySelector("body").style.overflow = "hidden";
        if (
          document.querySelector(".product--thumbnail_slider .thumbnail-slider")
        ) {
          document.querySelector(
            ".product--thumbnail_slider .thumbnail-slider"
          ).style.display = "none";
        }
      });
  }
  if (document.querySelector(".product-more-global-totems")) {
    document
      .querySelector(".product-more-global-totems")
      .addEventListener("click", function () {
        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__global-totems")
          .classList.toggle("visible");
        document
          .querySelector(".modal-product__global-totems .modal-product__body").style.display = 'grid'; 
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__global-totems"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }
        document.querySelector("body").style.overflow = "hidden";
        if (
          document.querySelector(".product--thumbnail_slider .thumbnail-slider")
        ) {
          document.querySelector(
            ".product--thumbnail_slider .thumbnail-slider"
          ).style.display = "none";
        }
      });
  }
  if (document.querySelector(".product-more-size")) {
    document
      .querySelector(".product-more-size")
      .addEventListener("click", function () {
        const topCoordinate = window.pageYOffset;

        document
          .querySelector(".modal-product__size")
          .classList.toggle("visible");
        if (window.innerWidth > 768) {
          document.querySelector(
            ".modal-product__size"
          ).style.top = `${topCoordinate}px`;
        } else {
          document.querySelector(
            "#shopify-section-product-modals"
          ).style.top = `${topCoordinate}px`;
        }
        document.querySelector("body").style.overflow = "hidden";
        document.querySelector(
          ".product--thumbnail_slider .thumbnail-slider"
        ).style.display = "none";
      });
  }

  if (document.querySelector(".modal-product__close")) {
    document.querySelectorAll(".modal-product__close").forEach((close) => {
      close.addEventListener("click", function () {
        const parent = this.closest(".modal-product");

        if (parent) {
          parent.classList.add("slide-out");
          setTimeout(() => {
            parent.classList.remove("visible", "slide-out");
          }, 1000);
        }
        if (
          document.querySelector(".product--thumbnail_slider .thumbnail-slider")
        ) {
          document.querySelector(
            ".product--thumbnail_slider .thumbnail-slider"
          ).style.display = "flex";
        }
        document.querySelector("body").style.overflowY = "auto";
      });
    });
  }
if(document.getElementById('popup')) {
 const popupCart = document.getElementById('popup');
  const triggerCart = document.querySelector('.cart-form-trigger');
  const closeBtnCart = document.querySelector('.popup-close');

  if(triggerCart) {
  triggerCart.addEventListener('click', () => {
    popupCart.style.display = 'block';
  });
  }
 
  closeBtnCart.addEventListener('click', () => {
    popupCart.style.display = 'none';
  });


  popupCart.addEventListener('click', (e) => {
    if (e.target === popupCart) {
      popupCart.style.display = 'none';
    }
  });
}

if(document.getElementById('popupBionic')) {
 const popupBionic = document.getElementById('popupBionic');
  const triggerBionic = document.querySelector('.product-modal-inquire p');
  const closeBtnBionic = document.querySelector('.popup-close');

  if(triggerBionic) {
  triggerBionic.addEventListener('click', () => {
    popupBionic.style.display = 'block';
  });
  }
 
  closeBtnBionic.addEventListener('click', () => {
    popupBionic.style.display = 'none';
  });


  popupBionic.addEventListener('click', (e) => {
    if (e.target === popupBionic) {
      popupBionic.style.display = 'none';
    }
  });
}

});
document.addEventListener("DOMContentLoaded", () => {
  const bgElements = document.querySelectorAll(".one-full-col__bg");
  bgElements.forEach((bgElement) => {
    if (bgElement) {
      const desktopBg = bgElement.dataset.desktopBg;
      const mobileBg =
        bgElement.dataset.mobileBg || bgElement.dataset.desktopBg;

      const updateBackground = () => {
        if (window.matchMedia("(max-width: 768px)").matches) {
          bgElement.style.backgroundImage = `url(${mobileBg})`;
        } else {
          bgElement.style.backgroundImage = `url(${desktopBg})`;
        }
      };

      updateBackground();

      window.addEventListener("resize", updateBackground);
    }
  });
  if (document.querySelector(".two-cols__static__bg")) {
    const bgElement = document.querySelector(".two-cols__static__bg");
    const desktopBg = bgElement.dataset.desktopBg;
    const mobileBg = bgElement.dataset.mobileBg || bgElement.dataset.desktopBg;

    const updateBackgroundTwo = () => {
      if (window.matchMedia("(max-width: 768px)").matches) {
        bgElement.style.backgroundImage = `url(${mobileBg})`;
      } else {
        bgElement.style.backgroundImage = `url(${desktopBg})`;
      }
    };

    updateBackgroundTwo();

    window.addEventListener("resize", updateBackgroundTwo);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let lastTrigger = null;
  let lastTargetPanel = "shop";

  function normalizeHandle(handle) {
    return (handle || "").trim().toLowerCase();
  }

  function setActivePreview(imageWrap, handle) {
    if (!imageWrap) return;

    const mediaItems = imageWrap.querySelectorAll(".custom-menu__preview-media");
    if (!mediaItems.length) return;

    const normalizedHandle = normalizeHandle(handle);

    mediaItems.forEach((item) => {
      const itemHandle = normalizeHandle(item.getAttribute("data-menu-handle"));
      item.classList.toggle(
        "is-active",
        !!normalizedHandle && itemHandle === normalizedHandle
      );
    });
  }

  function getMenuFromNode(node) {
    if (!(node instanceof Element)) return null;
    return node.closest(".custom-menu");
  }

  function syncPanels(menu, targetPanel) {
    if (!menu) return;

    const isMobile = window.innerWidth <= 1024;
    const activePanel = targetPanel || "shop";

    menu.querySelectorAll("[data-custom-menu-panel]").forEach((panel) => {
      if (isMobile) {
        panel.removeAttribute("hidden");
        panel.classList.add("is-active");
        return;
      }

      const isActive = panel.dataset.customMenuPanel === activePanel;
      panel.toggleAttribute("hidden", !isActive);
      panel.classList.toggle("is-active", isActive);
    });
  }

  const MOBILE_MENU_MQ = window.matchMedia("(max-width: 1024px)");

  function isMobileMenuViewport() {
    return MOBILE_MENU_MQ.matches;
  }

  function isMenuOpenTrigger(trigger) {
    if (!(trigger instanceof Element)) return false;
    if (trigger.closest(".custom-menu")) return false;
    if (!trigger.classList.contains("menu-trigger")) return false;
    if (trigger.hasAttribute("data-custom-menu-open")) return true;

    if (isMobileMenuViewport()) {
      return (
        trigger.classList.contains("menu-trigger__mobile") ||
        !trigger.closest(".custom-menu-triggers")
      );
    }

    return !trigger.classList.contains("menu-trigger__mobile");
  }

  function findMenuOpenTrigger(target) {
    if (!(target instanceof Element)) return null;
    const trigger = target.closest(
      "[data-custom-menu-open], .menu-trigger"
    );
    return isMenuOpenTrigger(trigger) ? trigger : null;
  }

  function openMenu(menu, closeButton) {
    if (!menu) return;
    menu.classList.add("is-open");
    menu.removeAttribute("inert");
    document.body.classList.add("custom-menu-open");
    document.body.style.overflowY = "hidden";
    closeButton?.focus({ preventScroll: true });
  }

  function closeMenu(menu, lastTrigger) {
    if (!menu) return;
    if (menu.contains(document.activeElement)) {
      document.activeElement?.blur?.();
      lastTrigger?.focus?.({ preventScroll: true });
    }
    menu.classList.remove("is-open");
    menu.setAttribute("inert", "");
    document.body.classList.remove("custom-menu-open");
    document.body.style.overflowY = "";
  }

  // Prevent focusing elements while closed
  document.querySelectorAll(".custom-menu").forEach((menu) => {
    menu.setAttribute("inert", "");
    syncPanels(menu, "shop");
  });

  window.addEventListener("resize", () => {
    document.querySelectorAll(".custom-menu").forEach((menu) => {
      syncPanels(menu, lastTargetPanel);
    });
  });

  // Delegated hover handler (survives dynamic section re-rendering)
  document.addEventListener(
    "pointerover",
    (e) => {
      if (!(e.target instanceof Element)) return;
      const item = e.target.closest("[data-menu-handle]");
      if (!item) return;

      const menu = getMenuFromNode(item);
      if (!menu) return;

      // Only react to hovers inside the menu list (not the preview images)
      if (!menu.querySelector(".custom-menu__list")?.contains(item)) return;

      const imageWrap = menu.querySelector(".custom-menu__image");
      setActivePreview(imageWrap, item.getAttribute("data-menu-handle"));
    },
    true
  );

  // Clear preview when leaving the menu list area
  document.querySelectorAll(".custom-menu__list").forEach((menuList) => {
    menuList.addEventListener("pointerleave", () => {
      const menu = getMenuFromNode(menuList);
      const imageWrap = menu?.querySelector(".custom-menu__image");
      setActivePreview(imageWrap, null);
    });
  });

  function handleMenuOpen(trigger) {
    lastTrigger = trigger;
    const targetPanel = trigger.dataset.customMenuTarget || "shop";
    lastTargetPanel = targetPanel;
    const menu = document.querySelector(".custom-menu");
    const closeButton = menu?.querySelector(".custom-menu__close-trigger");
    const imageWrap = menu?.querySelector(".custom-menu__image");

    syncPanels(menu, targetPanel);
    setActivePreview(imageWrap, null);
    openMenu(menu, closeButton);
  }

  let pendingMenuTouch = null;
  let bodyTouchStart = null;

  document.addEventListener(
    "touchstart",
    (event) => {
      if (event.touches.length !== 1) {
        pendingMenuTouch = null;
        bodyTouchStart = null;
        return;
      }

      const x = event.touches[0].clientX;
      const y = event.touches[0].clientY;
      const trigger = findMenuOpenTrigger(event.target);

      pendingMenuTouch = trigger ? { trigger, x, y } : null;
      bodyTouchStart = document.querySelector(".custom-menu.is-open")
        ? null
        : { x, y };
    },
    { passive: true }
  );

  document.addEventListener(
    "touchcancel",
    () => {
      pendingMenuTouch = null;
      bodyTouchStart = null;
    },
    { passive: true }
  );

  document.addEventListener(
    "touchend",
    (event) => {
      if (pendingMenuTouch && event.changedTouches.length === 1) {
        const { trigger, x, y } = pendingMenuTouch;
        const end = event.changedTouches[0];
        if (Math.abs(end.clientX - x) > 12 || Math.abs(end.clientY - y) > 12) {
          trigger.dataset.suppressMenuClick = "1";
        }
      }
      pendingMenuTouch = null;
      bodyTouchStart = null;
    },
    { passive: true }
  );

  document.addEventListener("click", (event) => {
    const trigger = findMenuOpenTrigger(event.target);
    if (!trigger) return;

    if (trigger.dataset.suppressMenuClick === "1") {
      delete trigger.dataset.suppressMenuClick;
      event.preventDefault();
      return;
    }

    handleMenuOpen(trigger);
  });

  document.addEventListener(
    "touchmove",
    (event) => {
      if (document.querySelector(".custom-menu.is-open") || !bodyTouchStart) return;
      if (!(event.target instanceof Element)) return;
      if (
        event.target.closest(
          ".slider, .swiper, .swiper-container, slider-component, .collection-list.slider"
        )
      ) {
        return;
      }

      const touch = event.touches[0];
      const deltaX = touch.clientX - bodyTouchStart.x;
      const deltaY = touch.clientY - bodyTouchStart.y;

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
        event.preventDefault();
      }
    },
    { passive: false }
  );

  document.querySelectorAll(".custom-menu").forEach((menu) => {
    const closeButton = menu.querySelector(".custom-menu__close-trigger");
    closeButton?.addEventListener("click", () => {
      closeMenu(menu, lastTrigger);
    });

    const firstPartMenu = menu.querySelector(".custom-menu__list");
    menu.addEventListener("click", function (event) {
      if (firstPartMenu && !firstPartMenu.contains(event.target)) {
        closeMenu(menu, lastTrigger);
      }
    });
  });
});

window.addEventListener("load", function () {
  if (
    document.querySelector(".collection-template div.section-header") &&
    document.querySelector(".parent-collection-slider__section")
  ) {
    const header = document.querySelector(
      ".collection-template div.section-header"
    );
    const topSection = document.querySelector(
      ".parent-collection-slider__section"
    );
    const sliderHeight = topSection.offsetHeight;
    const headerHeight = header.offsetHeight;
    const totalHeight = sliderHeight + headerHeight - 40;
    const toolbar = document.querySelector("#gf-controls-container");
    const grid = document.querySelector("#gf-grid");

    let stuckAtY = null;

    function throttle(func, limit) {
      let inThrottle;
      return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(() => (inThrottle = false), limit);
        }
      };
    }

    document.addEventListener(
      "scroll",
      throttle(function () {
        const width = window.innerWidth;
        const currentY = window.scrollY;

        if (width > 768) {
          if (toolbar) {
            if (currentY > totalHeight) {
              toolbar.classList.add("stuck");
              grid.classList.add("wrap-stuck");
              stuckAtY = currentY;
            } else {
              toolbar.classList.remove("stuck");
              grid.classList.remove("wrap-stuck");
              stuckAtY = null;
            }

            if (stuckAtY !== null && currentY > stuckAtY + 60) {
              toolbar.classList.remove("stuck");
              grid.classList.remove("wrap-stuck");
              stuckAtY = null;
            }
          }
        } else {
          if (toolbar) {
            if (currentY > topSection.offsetHeight) {
              toolbar.classList.add("stuck");
            } else {
              toolbar.classList.remove("stuck");
            }
          }
        }
      }, 100)
    );
  }

  document.addEventListener("scroll", function () {
    const stuckBar = document.querySelector(".totem-horizontal-slider-wrapper");
    const stuckNextBar = document.querySelector(
      ".totem-item .artisanal-inner-top-section"
    );
    const oneViewportHeight = window.innerHeight;
    if (width > 768) {
      if (stuckBar) {
        if (stuckNextBar) {
          if (window.scrollY > 114) {
            stuckBar.classList.add("stuck");
            stuckNextBar.classList.add("stuck-next");
          } else {
            stuckBar.classList.remove("stuck");
            stuckNextBar.classList.remove("stuck-next");
          }
        }
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const url = new URL(window.location.href);
  const page = url.searchParams.get("page");
  if (page && Number(page) > 1 && performance.navigation.type === 1) {
    url.searchParams.delete("page");
    window.location.replace(url.toString());
  }
});

document.querySelectorAll(".contact__sidebar a").forEach((link) => {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    const targetId = this.getAttribute("href");
    const target = document.querySelector(targetId);
    if (target) {
      const offset = -192;
      const targetPosition =
        target.getBoundingClientRect().top + window.pageYOffset + offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".contact-menu__mobile-trigger");
  const menu = document.querySelector(".contact-menu__mobile-menu");
  const main = document.querySelector("main");
  const links = document.querySelectorAll(".contact-menu__mobile-menu a");
  const close = document.querySelector(".contact-menu__mobile-menu--close");
  const offset = 68;
  if (trigger) {
    trigger.addEventListener("click", () => {
      menu.classList.toggle("active");
      main.classList.toggle('contact-main');
    });
  }
  if (links) {
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("href");
        const target = document.querySelector(targetId);

        if (target) {
          menu.classList.remove("active");
           main.classList.remove('contact-main');
          const targetPosition =
            target.getBoundingClientRect().top + window.pageYOffset + offset;

          setTimeout(() => {
            const top =
              target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
              top: top,
              behavior: "smooth",
            });
          }, 300);
        }
      });
    });
  }
  if (close) {
    close.addEventListener("click", () => {
      menu.classList.remove("active");
      main.classList.remove('contact-main');
    });
  }
});

function getIsZoomedDisplay() {
  const baseWidths = {
    3: 390,
  };
  const dpr = window.devicePixelRatio;
  const width = window.innerWidth;

  return baseWidths[dpr] && width < baseWidths[dpr];
}

if (getIsZoomedDisplay()) {
  document.body.classList.add("zoomed-view");
}
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".parent-collection-slider__section")) {
document.querySelectorAll(".parent-collection-slider__section")
  .forEach(section => {
    const wrapper = section.querySelector(".swiper-wrapper");
    if (wrapper && !wrapper.children.length) {
      section.classList.add("empty");
    }
  });
  }
  // if(document.querySelector(".totem-template")) {
  //   if(window.innerWidth > 768) {
  //   let scrollTop = '';
  //   if(window.innerWidth > 1025) {
  //     scrollTop = 114;
  //   } else  {
  //     scrollTop = 94;
  //   }
      
  // const totemHeader = document.querySelector(".totem-horizontal-slider-wrapper");
  

  // if (!totemHeader) return;

  // window.addEventListener("scroll", () => {
  //   console.log(window.scrollY);
  //   if (window.scrollY > scrollTop) {
  //     totemHeader.classList.add("is-sticky");
  //   } else {
  //     totemHeader.classList.remove("is-sticky");
  //   }
  // });
  //   }
  // }

  if (document.querySelector(".joy-parallax .parallax-section__content")) {
    const windowHeight = window.innerHeight;
    const section = document.querySelector(
      ".joy-parallax .parallax-section__content"
    );
    const height = section.offsetHeight;
    document.querySelector(".joy-parallax").style.height = `${height}px`;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(
    ".service-faqs__accordion .faqs-item"
  );

  function slideUp(element, duration = 300) {
    element.style.height = element.offsetHeight + "px";
    element.offsetHeight;
    element.style.transitionProperty = "height, margin, padding";
    element.style.transitionDuration = duration + "ms";
    element.style.boxSizing = "border-box";
    element.style.overflow = "hidden";
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    window.setTimeout(() => {
      element.style.display = "none";
      element.style.removeProperty("height");
      element.style.removeProperty("padding-top");
      element.style.removeProperty("padding-bottom");
      element.style.removeProperty("margin-top");
      element.style.removeProperty("margin-bottom");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition-duration");
      element.style.removeProperty("transition-property");
    }, duration);
  }

  function slideDown(element, duration = 300) {
    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;
    let height = element.offsetHeight;
    element.style.overflow = "hidden";
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    element.offsetHeight;
    element.style.boxSizing = "border-box";
    element.style.transitionProperty = "height, margin, padding";
    element.style.transitionDuration = duration + "ms";
    element.style.height = height + "px";
    element.style.removeProperty("padding-top");
    element.style.removeProperty("padding-bottom");
    element.style.removeProperty("margin-top");
    element.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition-duration");
      element.style.removeProperty("transition-property");
    }, duration);
  }

  function slideToggle(element, duration = 300) {
    if (window.getComputedStyle(element).display === "none") {
      return slideDown(element, duration);
    } else {
      return slideUp(element, duration);
    }
  }

  faqItems.forEach((item) => {
    const header = item.querySelector(".faqs-header");
    const content = item.querySelector(".faqs-content");
    const plusIcon = item.querySelector(".faqs-plus");
    const minusIcon = item.querySelector(".faqs-minus");

    content.style.display = "none";
    minusIcon.style.display = "none";

    header.addEventListener("click", () => {
      const isOpen = item.classList.contains("open");

      if (isOpen) {
        item.classList.remove("open");
        slideUp(content);
        plusIcon.style.display = "inline-block";
        minusIcon.style.display = "none";
      } else {
        item.classList.add("open");
        slideDown(content);
        plusIcon.style.display = "none";
        minusIcon.style.display = "inline-block";
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".mute-icon")) {
    const video = document.querySelector(".home-top__video video");
    const muteButton = document.querySelector(".mute-icon");

    muteButton.addEventListener("click", () => {
      video.muted = !video.muted;
      muteButton.textContent = video.muted ? "Unmute" : "Mute";
    });
  }
  function stickyTitle(selector, scroller = window) {
    const OFFSET = 112;
    const sectionTitled = document.querySelector(selector);

    if (!sectionTitled) return;

    const title = sectionTitled.querySelector(".one-full-col__title");

    if (!title) return;

    function updateStickyTitles() {
      const rect = sectionTitled.getBoundingClientRect();
      const titleHeight = title.offsetHeight;
      const start = rect.top;
      const end = rect.bottom;

      if (start <= 2 && end >= 20) {
        title.classList.add("title-stuck");
      } else {
        title.classList.remove("title-stuck");
      }
    }

    scroller.addEventListener("scroll", updateStickyTitles, { passive: true });
    window.addEventListener("resize", updateStickyTitles);
    updateStickyTitles();
  }

  function stickyTitleStatic() {
    const OFFSET = 112;
    const scroller = window;
    const section = document.querySelector(".two-cols__static");
    if (!scroller || !section) return;

    const title = section.querySelector("h2");
    if (!title) return;

    function updateStickyTitlesStatic() {
      const rect = section.getBoundingClientRect();
      const titleHeight = title.offsetHeight;

      const start = rect.top;
      const end = rect.bottom;

      if (start <= 2 && end >= 85) {
        title.classList.add("title-stuck");
      } else {
        title.classList.remove("title-stuck");
      }
    }

    scroller.addEventListener("scroll", updateStickyTitlesStatic, {
      passive: true,
    });
    window.addEventListener("resize", updateStickyTitlesStatic);
    updateStickyTitlesStatic();
  }

  function stickyTitleSlider() {
    const OFFSET = 112;
    const scroller = window;
    const section = document.querySelector(".two-cols__slider");
    if (!scroller || !section) return;

    const title = section.querySelector("h2.two-cols__slider--mobile-title");
    if (!title) return;

    function updateStickyTitlesSlider() {
      const rect = section.getBoundingClientRect();
      const titleHeight = title.offsetHeight;

      const start = rect.top;
      const end = rect.bottom;

      if (start <= 2 && end >= 85) {
        title.classList.add("title-stuck");
      } else {
        title.classList.remove("title-stuck");
      }
    }

    scroller.addEventListener("scroll", updateStickyTitlesSlider, {
      passive: true,
    });
    window.addEventListener("resize", updateStickyTitlesSlider);
    updateStickyTitlesSlider();
  }

  const isMobileTitle = window.innerWidth < 768;

  if (isMobileTitle) {
    stickyTitle("main.index-main .shopify-section:nth-child(2)");
    stickyTitle("main.index-main .shopify-section:nth-child(3)");
    stickyTitle("main.index-main .shopify-section:nth-child(4)");
    stickyTitleStatic();
    stickyTitleSlider();
  }

  document.querySelectorAll('.option-image').forEach(image => {
  const width = window.innerWidth;
  if(width > 1033) {
  image.addEventListener('click', function() {
    
    const optionCard = this.closest('.option-row');
    const selectedValue = optionCard.getAttribute('data-option');
    const existingMsg = optionCard.querySelector('.option-confirmation');
   const optionContentEl = optionCard.querySelector(".option-content");
    const optionText =
      (existingMsg
        ? optionContentEl.getAttribute("data-original-text")
        : optionContentEl.textContent.trim());

    document.querySelectorAll('.option-row').forEach(card => {
      if (card === optionCard) return;
     card.classList.remove("selected");
      const msgInCard = card.querySelector(".option-confirmation");
      const contentEl = card.querySelector(".option-content");

      if (msgInCard) {
        msgInCard.remove();
        const restoreText =
          contentEl.getAttribute("data-original-text");
        contentEl.textContent = "";
        contentEl.insertAdjacentHTML("beforeend", restoreText);
      }
    });
    
    if (!existingMsg) {
      optionCard.classList.add('selected');
      document.getElementById('selected-option').value = selectedValue;
      const optionContent = optionCard.querySelector('.option-content');
      const htmlString = `<div class='option-confirmation'></div>`;
        optionContent.textContent = '';
      optionContent.insertAdjacentHTML('beforeend', htmlString);
    }
  
  });
  }
});

 document.querySelectorAll('.option-image img').forEach(image => {
  image.addEventListener('click', function() {
    const width = window.innerWidth;
    if (width < 1033) {
    const optionCard = this.closest('.option-row');
    console.log(optionCard);
    const selectedValue = optionCard.getAttribute('data-option');
    const existingMsg = optionCard.querySelector('.option-confirmation');
   const optionContentEl = optionCard.querySelector(".option-content");
    const optionText =
      (existingMsg
        ? optionContentEl.getAttribute("data-original-text")
        : optionContentEl.textContent.trim());

    document.querySelectorAll('.option-row').forEach(card => {
      if (card === optionCard) return;
     card.classList.remove("selected");
      const msgInCard = card.querySelector(".option-confirmation");
      const contentEl = card.querySelector(".option-content");

      if (msgInCard) {
        msgInCard.remove();
        const restoreText =
          contentEl.getAttribute("data-original-text");
        contentEl.textContent = "";
        contentEl.insertAdjacentHTML("beforeend", restoreText);
      }
    });
    
    if (!existingMsg) {
      optionCard.classList.add('selected');
      document.getElementById('selected-option').value = selectedValue;
      const optionContent = optionCard.querySelector('.option-content');
      const htmlString = `<div class='option-confirmation'></div>`;
      optionContent.insertAdjacentHTML('beforeend', htmlString);
    }
    }
  });

});


});

function initStickyCart() {
  const cartItems = document.querySelector('.cart-items');
  const cartFooter = document.querySelector('.shopify-section.cart__footer-wrapper');
  const donation = document.querySelector('.donation-intro');
 const heightViewport = window.innerHeight;
  if (!cartItems || !cartFooter) return;
const rect = cartItems.getBoundingClientRect();
const bottom = rect.bottom + 20;
const widthViewport = window.innerWidth;

const widthCart = cartItems.offsetWidth + 100;
const rightPoint = (widthViewport - widthCart) / 2 ;
const footerHeight = cartFooter.offsetHeight;
   const heightTop = heightViewport - bottom - footerHeight;
  const observer = new ResizeObserver(entries => {
    for (let entry of entries) {
      
          document.documentElement.style.setProperty('--checkout-height', `${footerHeight}px`);
      const cartMainEl = document.querySelector('.cart-main');
      if (cartMainEl && window.innerWidth <= 767) {
        cartMainEl.classList.toggle('cart-content-tall', cartFooter.offsetTop > window.innerHeight);
      }
 
    
    cartFooter.style.position = 'sticky';
    cartFooter.style.bottom = '-5px';
    cartFooter.style.top = 'auto';
cartFooter.style.right = `${rightPoint}px`;
const observerDonation = new IntersectionObserver(entries => {
  for (let entry of entries) {
    if (entry.isIntersecting) {
 
      cartFooter.style.position = 'sticky';
      cartFooter.style.bottom = '-5px';
      cartFooter.style.top = 'auto';
      cartFooter.style.right = 'auto'; 
      

    }
  }
}, { threshold: 0 });

observerDonation.observe(donation);
   
    }
  });

  observer.observe(cartItems);
  
  const isTargetGadget = () => {
  const w = window.screen.width;
  const h = window.screen.height;

  const longestSide = Math.max(w, h);
  const shortestSide = Math.min(w, h);

  return longestSide > 1150 && shortestSide > 820;
};

 if (isTargetGadget()) {
    const CART_ITEMS_OFFSET_PX = 120;
    const SHOPIFY_FOOTER_BOTTOM_PX = 100;

    const updateCartFooterBottom = () => {
      const top = cartItems.getBoundingClientRect().top;
      const offsetReached = top <= -CART_ITEMS_OFFSET_PX;
      cartFooter.style.position = "sticky";
      cartFooter.style.top = "auto";
      cartFooter.style.right = "auto";
      cartFooter.style.left = "auto";
      cartFooter.style.transform = "none";
      cartFooter.style.bottom = '-5px';
    };

    if (cartFooter._targetGadgetScrollHandler) {
      window.removeEventListener("scroll", cartFooter._targetGadgetScrollHandler);
      window.removeEventListener("resize", cartFooter._targetGadgetScrollHandler);
    }
    cartFooter._targetGadgetScrollHandler = updateCartFooterBottom;
    window.addEventListener("scroll", updateCartFooterBottom);
    window.addEventListener("resize", updateCartFooterBottom);
    updateCartFooterBottom();
  }

 const cartMain = document.querySelector(".cart-main");
  const siteFooter = document.querySelector(".footer");

  if (
    cartMain &&
    cartItems &&
    siteFooter &&
    window.innerWidth <= 767 &&
    !cartMain.dataset.cartFooterObserverSet
  ) {
    cartMain.dataset.cartFooterObserverSet = "1";
    const state = { cartItems: false };
    const cartFooterSection = document.querySelector(
      ".shopify-section.cart__footer-wrapper",
    );


    let footerVisible = false;

    const updateCartFooterTop = () => {
      const mainRect = cartMain.getBoundingClientRect();
      const itemsRect = cartItems.getBoundingClientRect();
      const top = itemsRect.bottom - mainRect.top;
      document.documentElement.style.setProperty(
        "--cart-footer-absolute-top",
        `${top}px`,
      );
    };

    const applyFooterVisibleFlag = () => {
      if (cartMain) {
        cartMain.classList.toggle("footer-in-view", footerVisible);
        cartMain.classList.toggle(
          "cart-items-in-view",
          !footerVisible && state.cartItems,
        );
        if (!footerVisible && state.cartItems) updateCartFooterTop();
      }
      if (cartFooterSection) {
        cartFooterSection.classList.toggle("footer-in-view", footerVisible);
      }
    };

    const setFooterVisible = (value) => {
      if (footerVisible === value) return;
      footerVisible = value;
      applyFooterVisibleFlag();
    };

    const FOOTER_TRIGGER_OFFSET = 80;
    const FOOTER_HYSTERESIS_SCROLL = 40;

    let footerTriggerScrollY = null;

    const recalcFooterTrigger = () => {
      const rect = cartMain.getBoundingClientRect();
      const topPage = window.scrollY + rect.top;
      const height = cartMain.offsetHeight;
      footerTriggerScrollY =
        topPage + height - FOOTER_TRIGGER_OFFSET - window.innerHeight;
    };

    const footerTriggerHandler = () => {
      if (footerTriggerScrollY == null) {
        recalcFooterTrigger();
      }
      const y = window.scrollY;
      if (!footerVisible && y >= footerTriggerScrollY + FOOTER_HYSTERESIS_SCROLL) {
        setFooterVisible(true);
      } else if (
        footerVisible &&
        y <= footerTriggerScrollY - FOOTER_HYSTERESIS_SCROLL
      ) {
        setFooterVisible(false);
      }
    };

    window.addEventListener("scroll", footerTriggerHandler);
    window.addEventListener("resize", () => {
      recalcFooterTrigger();
      footerTriggerHandler();
    });
    cartMain._footerTriggerHandler = footerTriggerHandler;

    const cartItemsRootMargin = `${Math.min(
      100,
      window.innerHeight * 0.1,
    )}px 0px 0px 0px`;
    const cartItemsObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) state.cartItems = entry.isIntersecting;
        applyFooterVisibleFlag();
      },
      { threshold: 0, rootMargin: cartItemsRootMargin },
    );
    cartItemsObserver.observe(cartItems);
    updateCartFooterTop();
    recalcFooterTrigger();
    footerTriggerHandler();
    applyFooterVisibleFlag();
  } else if (cartMain && window.innerWidth > 767) {
    cartMain.classList.remove("cart-items-in-view", "footer-in-view");
    if (cartMain._footerTriggerHandler) {
      window.removeEventListener("scroll", cartMain._footerTriggerHandler);
      window.removeEventListener("resize", cartMain._footerTriggerHandler);
      delete cartMain._footerTriggerHandler;
    }
    delete cartMain.dataset.cartFooterObserverSet;
  }
}

document.addEventListener('DOMContentLoaded', initStickyCart);
window.addEventListener('resize', initStickyCart);
document.addEventListener('shopify:section:load', initStickyCart);


if(document.getElementById('orbitLinks')) {
    const RADIUS = 350;
    const DURATION_MS = 48000;

    const linksSource = document.getElementById('orbitLinks');

    const linkEls = linksSource ? linksSource.querySelectorAll('a') : [];
    const links = Array.from(linkEls).map(function (a) {
      return {
        href: a.getAttribute('href') || '#',
        img: a.getAttribute('data-img') || '',
        text: (a.textContent || '').trim() || '',
      };
    });
    const orbitInner = document.getElementById('orbitInner');
    const angleStep = links.length > 0 ? (2 * Math.PI) / links.length : 0;
    const items = [];
    const start = performance.now();

    links.forEach(function (link, i) {
      const wrapper = document.createElement('div');
      wrapper.className = 'orbit-item';
      const a = document.createElement('a');
      a.href = link.href;
      a.img = link.img;
      a.text = link.text;
      a.innerHTML = `
                <img src="${link.img}" alt="" loading="lazy">
                <span>${link.text}</span>
            `;
      wrapper.appendChild(a);
      orbitInner.appendChild(wrapper);
      items.push({ el: wrapper, baseAngle: i * angleStep });

    wrapper.addEventListener("click", function (event) {
            const href = link.href || "";
            const hashIndex = href.indexOf("#");


            if (hashIndex === -1) {
              return;
            }

            event.preventDefault();

            const targetId = href.slice(hashIndex + 1);
            if (!targetId) return;

            const targetEl =
              document.getElementById(targetId) ||
              document.querySelector('[data-anchor="' + targetId + '"]');

            if (!targetEl) {
              return;
            }

            if (window.gsap && window.gsap.to) {
              try {
                window.gsap.to(window, {
                  duration: 1,
                  scrollTo: {
                    y: targetEl,
                    offsetY: 1,
                    autoKill: true,
                  },
                  ease: "power2.out",
                  onComplete: function () {
                     document.body.style.overflow = "";
                    document.body.style.height = "";
                    if (window.history && window.history.replaceState) {
                      var cleanUrl =
                        window.location.pathname + window.location.search;
                      window.history.replaceState(null, "", cleanUrl);
                    }
                  },
                });
              } catch (e) {
               
                targetEl.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
                if (window.history && window.history.replaceState) {
                  var cleanUrl =
                    window.location.pathname + window.location.search;
                  window.history.replaceState(null, "", cleanUrl);
                }
              }
            } else {
              
              targetEl.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
              if (window.history && window.history.replaceState) {
                var cleanUrl =
                  window.location.pathname + window.location.search;
                window.history.replaceState(null, "", cleanUrl);
              }
            }
          });

    });

    function update() {
      const elapsed = (performance.now() - start) % DURATION_MS;
      const rotation = (elapsed / DURATION_MS) * 2 * Math.PI;
      items.forEach(function (item) {
        const angle = item.baseAngle + rotation;
        const x = RADIUS * Math.sin(angle);
        const y = -RADIUS * Math.cos(angle);
        item.el.style.transform = 'translate(calc(-50% + ' + x + 'px), calc(-50% + ' + y + 'px))';
      });
      requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }



function setCookieSignUp(name, value, days) {
  const expires = new Date(Date.now() + days*24*60*60*1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}
function getCookieSignUp(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(';').shift() : null;
}


const KLAVIYO_FORM_ID = "XqGTdN";


const alreadySubscribed = !!getCookieSignUp('newsletter_signed_up');
const recentlyRejected  = !!getCookieSignUp('reject_signed_up');

if (!alreadySubscribed && !recentlyRejected) {
  let totalTime = parseInt(sessionStorage.getItem('newsletter_time') || '0', 10);

  window.addEventListener("klaviyoForms", function(e) {
    if (!e || !e.detail || e.detail.formId !== KLAVIYO_FORM_ID) return;

    if (e.detail.type === "submit") {
      setCookieSignUp('newsletter_signed_up', 'true', 365);
    } else if (e.detail.type === "close") {
      setCookieSignUp('reject_signed_up', 'true', 1);
    }
  });

  const timer = setInterval(() => {
    totalTime += 1;
    sessionStorage.setItem('newsletter_time', String(totalTime));

    if (totalTime >= 53) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', KLAVIYO_FORM_ID]);

      clearInterval(timer);
      sessionStorage.setItem('newsletter_time_lock', '1');
    }
  }, 1000);

 
  if (sessionStorage.getItem('newsletter_time_lock') === '1') {
    clearInterval(timer);
  }
}
const triggerExpressness = document.querySelector(".expresness-slider");
const targetExpressness = document.querySelector(".product--thumbnail_slider .thumbnail-slider");

if (triggerExpressness && targetExpressness) {
  const observer6 = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        targetExpressness.classList.add("z-index-0");
      } else {
        targetExpressness.classList.remove("z-index-0");
      }
    },
    {
      threshold: 0
    }
  );

  observer6.observe(triggerExpressness);
}

  function initCardHoverVideo() {
    const section = document.querySelector('.collection-list');
    if (!section) return;

    const prefersHover = window.matchMedia('(hover: hover)').matches;

    section.querySelectorAll('.collection-list__item--has-hover').forEach(function (item) {
      const hoverVideo = item.querySelector('.collection-card__media-hover-video');
      if (!hoverVideo) return;

      function playHover() {
        if (hoverVideo.readyState < 2) hoverVideo.load();
        hoverVideo.play().catch(function () {});
      }

      function pauseHover() {
        hoverVideo.pause();
        hoverVideo.currentTime = 0;
      }

      if (prefersHover) {
        item.addEventListener('mouseenter', playHover);
        item.addEventListener('mouseleave', pauseHover);
      }
    });
  }


  if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCardHoverVideo, {
    once: true,
  });
} else {
  initCardHoverVideo();
}

function initOneColumnVideo() {
  const MOBILE_MQ = window.matchMedia("(max-width: 767px)");

  const isActiveVideo = (video) => {
    if (video.classList.contains("one-full-col__video--mobile")) {
      return MOBILE_MQ.matches;
    }
    if (video.classList.contains("one-full-col__video--desktop")) {
      return !MOBILE_MQ.matches || !video.closest("[data-has-mobile-video]");
    }
    return true;
  };

  const prepareVideo = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.playsInline = true;
    video.autoplay = true;
    video.loop = true;
    video.controls = false;
    video.removeAttribute("controls");
  };

  const tryPlay = (video) => {
    if (!isActiveVideo(video)) return;
    prepareVideo(video);
    const promise = video.play();
    if (promise?.catch) {
      promise.catch(() => {});
    }
  };

  const initSectionVideos = (section) => {
    if (section.dataset.videoInit === "true") return;
    section.dataset.videoInit = "true";

    const videos = section.querySelectorAll(".one-full-col__video");
    if (!videos.length) return;

    let touchStarted = false;
    const onFirstTouch = () => {
      if (touchStarted) return;
      touchStarted = true;
      videos.forEach(tryPlay);
    };

    videos.forEach((video) => {
      prepareVideo(video);

      ["loadedmetadata", "canplay", "loadeddata"].forEach((event) => {
        video.addEventListener(event, () => tryPlay(video));
      });

      document.addEventListener("touchstart", onFirstTouch, {
        once: true,
        passive: true,
      });
      document.addEventListener("click", onFirstTouch, { once: true });
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            tryPlay(entry.target);
          });
        },
        { threshold: 0.1 },
      );
      videos.forEach((video) => observer.observe(video));
    }

    videos.forEach(tryPlay);

    MOBILE_MQ.addEventListener("change", () => {
      videos.forEach((video) => {
        if (!isActiveVideo(video)) {
          video.pause();
          return;
        }
        tryPlay(video);
      });
    });

    window.addEventListener("pageshow", () => {
      videos.forEach(tryPlay);
    });

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        videos.forEach(tryPlay);
      }
    });
  };

  const initAllVideos = (root) => {
    (root || document)
      .querySelectorAll(".one-full-col--video")
      .forEach(initSectionVideos);
  };

  const boot = () => initAllVideos();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAllVideos(event.target);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOneColumnVideo, {
    once: true,
  });
} else {
  initOneColumnVideo();
}

function initTotemRow() {

    const sections = document.querySelectorAll('.totem-row-section');
    if (!sections.length) return;

    const prefersHover = window.matchMedia('(hover: hover)').matches;
    const TITLE_LEFT_OFFSET = 40;
    const titles = document.querySelectorAll('[data-totem-row-title]');

    function updateTitles() {
      const viewportCenter = window.innerHeight / 2;

      titles.forEach(function (title) {
        const col = title.closest('.totem-row-section__col');
        const sectionEl = title.closest('.totem-row-section');
        if (!col || !sectionEl) return;

        const colRect = col.getBoundingClientRect();
        const colCenter = colRect.top + colRect.height / 2;
        const titleHalf = title.offsetHeight / 2;
        const bottomOffset = Number(sectionEl.dataset.titleBottom) || 40;
        const bottomLimitCenter = colRect.bottom - bottomOffset - titleHalf;

        if (colCenter > viewportCenter) {
          title.dataset.state = 'above';
          title.style.left = '';
        } else if (bottomLimitCenter < viewportCenter) {
          title.dataset.state = 'below';
          title.style.left = '';
        } else {
          title.dataset.state = 'fixed';
          title.style.left = colRect.left + TITLE_LEFT_OFFSET + 'px';
        }
      });
    }

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateTitles();
        ticking = false;
      });
    }

    updateTitles();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateTitles);

    sections.forEach(function (sectionEl) {
      sectionEl.querySelectorAll('.totem-row-section__col').forEach(function (col) {
        if (!col.classList.contains('totem-row-section__col--has-hover')) return;

        const baseVideo = col.querySelector('.totem-row-section__video--base');
        const hoverVideo = col.querySelector('.totem-row-section__video--hover');

        if (prefersHover && !hoverVideo) return;

        function playHover() {
          if (hoverVideo) {
            if (hoverVideo.readyState < 2) hoverVideo.load();
            hoverVideo.play().catch(function () {});
          }
          if (baseVideo) baseVideo.pause();
        }

        function playBase() {
          if (hoverVideo) {
            hoverVideo.pause();
            hoverVideo.currentTime = 0;
          }
          if (baseVideo) baseVideo.play().catch(function () {});
        }

        if (prefersHover) {
          col.addEventListener('mouseenter', playHover);
          col.addEventListener('mouseleave', playBase);
        } else if (hoverVideo) {
          col.addEventListener('click', function () {
            const active = col.classList.toggle('is-hover-active');
            if (active) playHover();
            else playBase();
          });
        } else {
          col.addEventListener('click', function () {
            col.classList.toggle('is-hover-active');
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTotemRow);
} else {
  initTotemRow();
}
document.addEventListener('shopify:section:load', function (e) {
  if (e.target.matches('.totem-row-section')) {
    bindSection(e.target); 
  }
});